/**
 * Single page scripts.
 *
 * @package
 */

import '../sass/single.scss';

import SocialShare from './components/SocialShare';
import Podcast from './components/Podcast';

SocialShare.init();
Podcast.init();
